import React, { useEffect, useState } from "react";

import Post from "./Post";
import Typography from "@material-ui/core/Typography";
import { useDataProvider } from "react-admin";

import {
  Container,
  Content,
  Header,
  HeaderTitle,
  HeaderSubtitle,
  PostsGrid,
  SupportBox,
  DonationHeader,
  DonationBadge,
  DonationActions,
  CopyButton,
  PixImage,
  PixKey,
  SupportContent,
  SupportLogo,
  SupportDetails,
  SupportLabel,
  SupportValue,
} from "./style";

import DonationFloating from "./DonationFloating";

const Dashboard = (props) => {
  const dataProvider = useDataProvider();
  const [copyLabel, setCopyLabel] = useState("Copiar PIX");
  const [store, setStore] = useState({});

  const pixKey =
    "00020101021126580014br.gov.bcb.pix0136cfcf2287-3809-44e7-9f43-8cf85ffdd2da5204000053039865802BR5920ERICK ALVES DO COUTO6013RIO DE JANEIR62070503***63042431";
  const mbwayNumber = "351925564552";
  const mbwayDisplay = "+351 925 564 552";
  const currencyValue = String(store?.currency ?? "").trim();
  const currencyValueLower = currencyValue.toLowerCase();
  const isEuro =
    currencyValue.includes("€") ||
    currencyValueLower === "eur" ||
    currencyValueLower === "euro" ||
    currencyValueLower.includes("eur");

  useEffect(() => {
    dataProvider
      .getOne("configuration", {})
      .then((res) => {
        const storeData = res?.data?.data ?? res?.data ?? res;
        if (storeData) setStore(storeData);
      })
      .catch(() => {});
  }, [dataProvider]);

  useEffect(() => {
    setCopyLabel(isEuro ? "Copiar MB WAY" : "Copiar PIX");
  }, [isEuro]);

  const handleCopyPix = async () => {
    const supportKey = isEuro ? mbwayNumber : pixKey;
    try {
      await navigator.clipboard.writeText(supportKey);
      setCopyLabel(isEuro ? "MB WAY copiado!" : "PIX copiado!");
      setTimeout(
        () => setCopyLabel(isEuro ? "Copiar MB WAY" : "Copiar PIX"),
        2000
      );
    } catch (error) {
      setCopyLabel("Não foi possível copiar");
      setTimeout(
        () => setCopyLabel(isEuro ? "Copiar MB WAY" : "Copiar PIX"),
        2000
      );
    }
  };

  return (
    <Container>
      <DonationFloating
        pixKey={pixKey}
        currency={store?.currency}
        mbwayNumber={mbwayNumber}
        mbwayDisplay={mbwayDisplay}
      />
      <Content>
        <Header>
          <HeaderTitle>Atualizações e novidades</HeaderTitle>
          <HeaderSubtitle>
            Acompanhe recursos novos, dicas e comunicados do Menu Legal.
          </HeaderSubtitle>
        </Header>

        <PostsGrid>
          <Post
            date={"21 de Janeiro de 2026"}
            image={require("../../Assets/images/content/dashboard-update.png")}
          >
            <Typography variant="h6" component="h2">
              Dashboard atualizado com novo layout
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              O dashboard ganhou uma atualização de layout com melhorias de
              usabilidade para deixar a navegação mais rápida e clara.
            </Typography>
          </Post>

          <Post
            date={"24 de Maio de 2025"}
            image={require("../../Assets/images/content/donate.png")}
            highlight
          >
            <DonationHeader>
              <Typography variant="h6" component="h2">
                Colabore com o Menu Legal
              </Typography>
              <DonationBadge>Destaque</DonationBadge>
            </DonationHeader>
            <Typography variant="body2" color="textSecondary" component="p">
              Atualmente cobrimos do nosso bolso todos os custos do Menu Legal,
              como servidores, banco de dados, domínios, suporte e etc.
            </Typography>
            <br />
            <Typography variant="body2" color="textSecondary" component="p">
              Criamos o Menu Legal logo no início da pandemia do Covid-19 com o
              intuito de ajudar as pessoas a se conectarem mais facilmente com
              seus clientes de uma forma simples, rápida e acessível.
            </Typography>
            <br />
            <Typography variant="body2" color="textSecondary" component="p">
              Somos três desenvolvedores independentes e trabalhamos no Menu
              Legal em horário em que não estamos em nossos trabalhos
              principais. O que era um projeto pequeno se tornou uma ferramenta
              que já ajudou mais de 2000 estabelecimentos no mundo.
            </Typography>
            <br />
            <Typography variant="body2" color="textSecondary" component="p">
              Se gostou da ferramenta e gostaria de colaborar com qualquer
              valor, utilize a opção abaixo:
            </Typography>
            <br />
            <SupportBox>
              <DonationActions>
                {!isEuro && (
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    component="p"
                  >
                    Pix copia e cola
                  </Typography>
                )}
                <CopyButton type="button" onClick={handleCopyPix}>
                  {copyLabel}
                </CopyButton>
              </DonationActions>
              {!isEuro && (
                <>
                  <PixImage src={require("../../Assets/images/pix.png")} />
                  <PixKey>{pixKey}</PixKey>
                </>
              )}
              {isEuro && (
                <SupportContent>
                  <SupportLogo src={require("../../Assets/images/MB_WAY.jpg")} />
                  <SupportDetails>
                    <SupportLabel>MB WAY</SupportLabel>
                    <SupportValue>{mbwayDisplay}</SupportValue>
                    <PixKey>
                      Abra o MB WAY, escolha “Pagar” e use o número acima.
                    </PixKey>
                  </SupportDetails>
                </SupportContent>
              )}
            </SupportBox>
          </Post>

          <Post
            date={"22 de Março de 2021"}
            image={require("../../Assets/images/content/dias.png")}
          >
            <Typography variant="h6" component="h2">
              Disponibilidade do produto na semana
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              Agora ao criar ou editar um produto, você pode especificar quais
              dias da semana este produto poderá ficar disponível. Se o usuário
              acessar o menu em um dia que o produto não está disponível, ele
              ficará desabilitado automaticamente.
            </Typography>
          </Post>

          <Post
            date={"01 de Março de 2021"}
            image={require("../../Assets/images/content/busca.png")}
          >
            <Typography variant="h6" component="h2">
              Busca de produtos
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              Caso o seu cardápio tenha muitos produtos, agora você pode
              habilitar uma caixa de busca para facilitar a vída dos seus
              clientes. Para habilitar ou desabilitar, basta ir no menu
              Configurações, clicar na aba Configurações e alterar a o item
              "Habilitar busca de produtos".
            </Typography>
          </Post>

          <Post
            date={"18 de Fevereiro de 2021"}
            image={require("../../Assets/images/content/pagamentos.png")}
          >
            <Typography variant="h6" component="h2">
              Formas de pagamento
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              Agora você pode habilitar quais formas de pagamento você aceita em
              seu estabelecimento. Para isto basta clicar no menu configurações,
              selecionar a aba Configurações, habilitar os métodos de pagamento
              caso não esteja habilitado e selecionar os métodos que você
              aceita.
            </Typography>
          </Post>
        </PostsGrid>
      </Content>
    </Container>
  );
};

export default Dashboard;
